<template>
  <!-- REMOVIDA a propriedade 'app' daqui -->
  <v-navigation-drawer
    v-model="drawerComputed"
    :mini-variant="mini"
    mini-variant-width="72"
  >
    <v-list>
      <v-list-item to="/dashboard" link>
        <template v-slot:prepend>
          <v-icon>mdi-view-dashboard</v-icon>
        </template>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item>

      <v-list-item to="/messages" link>
        <template v-slot:prepend>
          <v-icon>mdi-message-text</v-icon>
        </template>
        <v-list-item-title>Mensagens</v-list-item-title>
      </v-list-item>

      <v-list-item to="/conectar" link>
        <template v-slot:prepend>
          <v-icon>mdi-qrcode-scan</v-icon>
        </template>
        <v-list-item-title>Conectar Instância</v-list-item-title>
      </v-list-item>

      <v-list-item @click="logout" link>
        <template v-slot:prepend>
          <v-icon>mdi-logout</v-icon>
        </template>
        <v-list-item-title>Sair</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'AppSidebar',
  props: {
    modelValue: Boolean,
    mini: Boolean
  },
  emits: ['update:modelValue'],
  computed: {
    drawerComputed: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  },
  methods: {
    logout() {
      console.log('Logout clicked');
    }
  }
}
</script>

<style scoped>
.v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>